<template>
  <!--
      作者：luoyiming
      时间：2019-10-25
      描述：加钟信息
  -->
  <div class="pb50">
    <div class="product-content">
      <!--商品信息-->
      <div class="common-form mt16">加钟信息</div>
      <div class="table-wrap">
        <el-table size="small" :data="detail.clockOrder" border style="width: 100%">
          <el-table-column prop="orderNo" label="订单编号"></el-table-column>
          <el-table-column prop="product[0].productName" label="产品名称"></el-table-column>
          <el-table-column prop="pay_price" label="支付金额">
            <template slot-scope="scope">
              <div class="orange">￥ {{scope.row.pay_price?scope.row.pay_price:0.00}} 元</div>
            </template>
          </el-table-column>
          <el-table-column prop="waiter_price" label="技师所得">
            <template slot-scope="scope">
              <div class="blue">￥ {{scope.row.waiter_price?scope.row.waiter_price:0.00}} 元</div>
            </template>
          </el-table-column>
          <el-table-column prop="supplier_price" label="商户所得">
            <template slot-scope="scope">
              <div class="red">￥ {{scope.row.supplier_price?scope.row.supplier_price:0.00}} 元</div>
            </template>
          </el-table-column>
          <el-table-column prop="sys_price" label="平台所得">
            <template slot-scope="scope">
              <div class="green">￥ {{scope.row.sys_price?scope.row.sys_price:0.00}} 元</div>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="isClock" label="加钟项目" min-width="100">
            <template slot-scope="scope">
              <div class="product-info">
                <div class="info">
                  <div v-if="scope.row.isClock==1" class="price">是</div>
                  <div v-else class="name">否</div>
                </div>
              </div>
            </template>
          </el-table-column> -->
          <el-table-column prop="createTime" label="创建时间"></el-table-column>
        </el-table>
      </div>

    </div>
  </div>
</template>

<script>
import OrderApi from "@/api/order.js";
import { deepClone } from "@/utils/base.js";
export default {
  inject: ["detail"],
  data() {
    return {
      /*是否加载完成*/
      loading: true
      /*订单数据*/
      // detail: {
      // 	product: [],
      // }
    };
  },
  created(e) {
    /*获取列表*/
    // this.getParams();
  },
  methods: {
    /*获取参数*/
    getParams() {
      let self = this;
      // 取到路由带过来的参数
      const params = this.$route.query.orderId;
      OrderApi.orderdetail(
        {
          orderId: params
        },
        true
      )
        .then(data => {
          self.loading = false;
          self.detail = data.data;
        })
        .catch(error => {
          self.loading = false;
        });
    }
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/order/order/part/bell.vue